export default {
  computed: {
    highchartsFormattedData() {
      if (Array.isArray(this.sampleData)) {
        return this.aggregateHighchartsData(
          this.sampleData.map(sample => this.transformDataToHighchartsFormat(Object.entries(sample)))
        );
      }

      return this.transformDataToHighchartsFormat(Object.entries(this.sampleData));
    }
  },
  methods: {
    convertPercentToPpm(sampleData) {
      return sampleData.map((...[entry, , entries]) => {
        const [key, value] = entry;
        const index = this.graphPercentProperties.findIndex(({ property }) => property === key);

        if (index !== -1) {
          const { unitOfMeasure } = this.graphPercentProperties[index];

          if (Object.fromEntries(entries)[unitOfMeasure] === '%') {
            return [key, value * 10000];
          }
        }

        return [key, value];
      });
    },

    roundValue(key, value) {
      if (['newOxidation', 'newSulfation', 'newNitration'].includes(key)) {
        return Math.round(value);
      }
      return value;
    },

    transformDataToHighchartsFormat(sampleData) {
      return sampleData
        .filter(entry => this.graphProps.some(({ name }) => name === entry[0]))
        .map(entry => {
          const [key, value] = entry;
          const roundedValue = this.roundValue(key, value);

          return {
            name: key,
            data: [roundedValue]
          };
        });
    },

    aggregateHighchartsData(sampleData) {
      return sampleData.reduce((accumulator, value) => {
        return accumulator.map(({ name, data }, index) => {
          return {
            name,
            data: [...data, ...value[index].data]
          };
        });
      });
    }
  }
};
